export type UserRole = 'user' | 'admin' | 'owner';

export type RoleLikeUser = {
  role?: string | null;
  is_admin?: boolean | null;
} | null | undefined;

export const normalizeUserRole = (user: RoleLikeUser): UserRole => {
  const role = String(user?.role || '').trim().toLowerCase();
  if (role === 'owner' || role === 'admin' || role === 'user') {
    return role;
  }
  return user?.is_admin ? 'admin' : 'user';
};

export const isOwner = (user: RoleLikeUser): boolean => normalizeUserRole(user) === 'owner';

export const isAdminOrOwner = (user: RoleLikeUser): boolean => {
  const role = normalizeUserRole(user);
  return role === 'admin' || role === 'owner';
};

export const getRoleLabel = (user: RoleLikeUser): string => {
  const role = normalizeUserRole(user);
  if (role === 'owner') return 'Владелец';
  if (role === 'admin') return 'Админ';
  return 'Пользователь';
};
